module.exports = __webpack_public_path__ + "media/bootstrap-icons/circle-fill-e4648e45.svg";